import { ComponentsOverrides, Theme } from '@mui/material';

import { muiPalette } from '@/shared/general-theme';

export const CardStyles= (palette: typeof muiPalette): ComponentsOverrides<Theme>['MuiCard'] =>
  ({
    root: {
      display: 'flex',
      backgroundImage: 'none',
      backgroundColor: palette.background.paper,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: palette.divider,
      borderRadius: 12,
    },
  });